import clsx from "clsx";
import { motion } from "framer-motion";

export function PlanPeriodToggle(props: {
	periodSelected: "monthly" | "annually";
	onPeriodChange: (period: "monthly" | "annually") => void;
}) {
	const { periodSelected, onPeriodChange } = props;

	return (
		<div className="flex justify-center mb-8">
			<div className="inline-flex p-1 bg-surface-subtle rounded-xl gap-1">
				<button
					type="button"
					onClick={() => onPeriodChange("monthly")}
					title="Show monthly plans"
					aria-label="Show monthly plans"
					className={clsx(
						"relative px-5 py-1.5 text-xs font-semibold rounded-lg transition-all duration-200",
						periodSelected === "monthly"
							? "text-brand-primary"
							: "text-text-secondary hover:text-text-primary hover:bg-surface-hover-subtle",
					)}
				>
					{periodSelected === "monthly" && (
						<motion.div
							layoutId="period-switch"
							className="absolute inset-0 bg-surface-default rounded-lg shadow-sm"
							transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
						/>
					)}
					<span className="relative z-10">Monthly</span>
				</button>
				<button
					type="button"
					onClick={() => onPeriodChange("annually")}
					title="Show annual plans"
					aria-label="Show annual plans"
					className={clsx(
						"relative px-5 py-1.5 text-xs font-semibold rounded-lg transition-all duration-200",
						periodSelected === "annually"
							? "text-brand-primary"
							: "text-text-secondary hover:text-text-primary hover:bg-surface-hover-subtle",
					)}
				>
					{periodSelected === "annually" && (
						<motion.div
							layoutId="period-switch"
							className="absolute inset-0 bg-surface-default rounded-lg shadow-sm"
							transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
						/>
					)}
					<span className="relative z-10">Annual</span>
				</button>
			</div>
		</div>
	);
}
